import React, { useEffect, useState } from 'react';
import { utils, writeFile } from 'xlsx';
import {
	Alert,
	Box,
	Button,
	Card,
	CardContent,
	CircularProgress,
	Container,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControl,
	Grid,
	IconButton,
	InputLabel,
	LinearProgress,
	MenuItem,
	Paper,
	Select,
	Snackbar,
	TextField,
	Tooltip,
	Typography,
	useMediaQuery,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import icon3 from '../../../assets/logos/icon3.png';
import MenuIcon from '@mui/icons-material/Menu';

import Icon from '../../../assets/logos/Icon.png';

import { DataGrid } from '@mui/x-data-grid';

import Group5 from '../../../assets/logos/Group5.png';

import Group6 from '../../../assets/logos/Group6.png';

import eye from '../../../assets/logos/eye.png';

import TablePagination from '@mui/material/TablePagination';

import icon5 from '../../../assets/logos/icon5.png';

import Menu from '@mui/material/Menu';

import MoreVertIcon from '@mui/icons-material/MoreVert';

import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';

import { useTheme } from '@emotion/react';
import {
	getBatches,
	getBatchesDetails,
	getBatchesWithbatch_id,
	getPracticeStaff,
	getUserPractices,
	getVisit,
	updateBatch,
} from '../../services/api/apiManager';
import dayjs from 'dayjs';
import { ArrowDropDown, Cancel } from '@mui/icons-material';
function Batches() {
	const practiceId_fromLocal = localStorage.getItem('practice_id');
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [postSucessfully, setPostSucessfully] = useState(true);
	const [batchDeleted, setBatchDeleted] = useState(false);
	const [reRenderAgain, setRerenderAgain] = useState(0);
	const [loader, setLoader] = useState(false);
	const [batchesLoader, setBatchesLoader] = useState(false);
	const [isClicked, setClicked] = useState(0);
	const [firstBatch, setfirstBatch] = useState({});
	const [open, setOpen] = useState(false);
	const [page, setPage] = React.useState(2);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [provider, setProvider] = useState('');
	const [filterData, setFilterData] = useState([]);
	const [searchBy, setSearchBy] = useState('');
	const [batchesStatus, setBatchesStatus] = useState('');
	const [filterBatchWithStatus, setFilterBatchWithStatus] = useState([]);
	const [batchesDetailsData, setBatchesDetailsData] = useState([]);
	const [allBatchData, setAllBatchData] = useState([]);
	const [currentlySelecteBatch, setCurrentlySelecteBatch] = useState({
		id: 0,
		BatchName: '',
		charges: 0,
		CreatedDate: '',
	});
	const [selectedBatchGrid, setSelectedBatchGrid] = useState([]);
	// update batch modal inputfields and button
	const [updateBatchName, setUpdateBatchName] = useState('');
	const [updateAssignTo, setUpdateAssignTo] = useState('');
	// const [updateBatchDescr, setUpdateBatchDescr] = useState('');

	const [practiceStaff, setPracticeStaff] = useState([]);
	const [visitData, setVisitData] = useState([]);
	// 	// pagination
	// Last 30 day visit
	const [paginationPage, setPaginationPage] = useState(1); // Set the initial page number
	const [pageSize, setPageSize] = useState(10); // Set the initial page size
	const [pagination, setPagination] = useState(null);
	const handleSearchByFilter = (event) => {
		setSearchBy(event.target.value);
		if (event.target.value === '') {
			setFilterData(selectedBatchGrid);
		} else {
			const searching = selectedBatchGrid?.filter((items) => {
				return (
					(
						items?.patient?.Fname.toLowerCase() +
						' ' +
						items?.patient?.Lname.toLowerCase()
					).includes(event.target.value?.toLowerCase().trim()) ||
					(
						items?.patient?.Lname.toLowerCase() +
						' ' +
						items?.patient?.Fname.toLowerCase()
					).includes(event.target.value?.toLowerCase().trim())
				);
			});
			setFilterData(searching);
		}
	};

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleClick = (items) => {
		setClicked(items.id);
		setCurrentlySelecteBatch({
			id: items?.id,
			BatchName: items?.BatchName,
			charges: items?.num_visits,
			CreatedDate:
				items?.AssignedTo === null
					? ''
					: dayjs(items?.CreatedDate).format('MM-DD-YYYY'),
		});
		// we filter visitData with match of batch id from here
		setSelectedBatchGrid(visitData?.filter((i) => i.batch_id == items.id));
		setFilterData(visitData?.filter((i) => i.batch_id == items.id));
	};

	const textStyles = (id) => ({
		padding: '10px',
		margin: '5px 8px',
		cursor: 'pointer',
		borderRadius: '10px',
		border: isClicked === id ? '1px solid #1D60C5' : '1px solid lightgray',
		// boxShadow: isClicked === id ? '0 0 1rem 1rem #F2F4F6' : 'none',
		// boxShadow: isClicked === id ? '0px 1px 15px 0px #075AD74F' : 'none',
		// backgroundColor: isClicked === id ? '#F2F4F6' : '#FBFDFF',
	});

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleCloseSnackbar = () => {
		setOpenSnackbar(false);
	};

	const batchesStatusHandler = (event) => {
		setBatchesStatus(event.target.value);
		const filteration = batchesDetailsData.filter((items) => {
			return items.BatchStatus == event.target.value;
		});
		if (event.target.value === 'E' || event.target.value === 'P') {
			setfirstBatch(filteration?.length > 0 ? filteration[0] : '');
		} else {
			setfirstBatch(allBatchData[0]);
		}

		setFilterBatchWithStatus(filteration);
	};

	const providerHandler = (event) => {
		setProvider(event.target.value);
	};
	const columns = [
		// {
		// 	field: 'icon',
		// 	headerName: '',
		// 	width: 5,
		// 	renderCell: () => {
		// 		return (
		// 			<div>
		// 				<img src={Group6} width="8.8px" style={{ cursor: 'pointer' }} />
		// 				,
		// 				<img src={Group5} width="17px" style={{ cursor: 'pointer' }} />
		// 			</div>
		// 		);
		// 	},
		// },
		{
			field: 'patientName',
			headerName: 'Patient Name',
			width: 130,
			// flex: 1,
		},
		{
			field: 'ProviderName',
			headerName: 'Provider Name',
			// flex: 1,
			width: 130,
		},
		{
			field: 'visitDate',
			headerName: 'Visit Date',
			width: 130,
		},
		{
			field: 'charges',
			headerName: 'Charges',
			width: 200,
			flex: 1,
			renderCell: (params) => (
				<Box>
					<Typography
						sx={{
							fontFamily: 'Poppins',
							fontWeight: '400',
							fontSize: '12px',
							color: '#000000',
							textOverflow: 'ellipsis',
							overflow: 'hidden',
							whiteSpace: 'nowrap',
						}}
					>
						<span
							style={{
								color: '#075AD7',
								fontWeight: '600',
								textOverflow: 'ellipsis',
								overflow: 'hidden',
								whiteSpace: 'nowrap',
							}}
						>
							{' '}
							{params?.row?.charges?.length > 0
								? params?.row?.charges?.map((data) =>
										data?.CPTCode === null ? '' : data?.CPTCode + ','
									)
								: ''}
						</span>
						{/* {params.row.charges.length > 0
							? params.row.charges.map((data) => data.Description + '')
							: ' '}{' '} */}
						<br />
						<Tooltip
							sx={{
								'& .MuiTooltip-tooltip': {
									letterSpacing: 2,
								},
							}}
							title={
								<>
									{`${params.row.Dxcode1 !== null ? params.row.Dxcode1 : ''} ${params.row.Dx1Description}`}{' '}
									{params?.row?.Dx1Description && <br />}
									{` ${params.row.Dxcode2 !== null ? params.row.Dxcode2 : ''} ${params.row.Dx2Description}`}
									{params?.row?.Dx2Description && <br />}
									{` ${params.row.Dxcode3 !== null ? params.row.Dxcode3 : ''} ${params.row.Dx3Description}`}
									{params?.row?.Dx3Description && <br />}
									{` ${params.row.Dxcode4 !== null ? params.row.Dxcode4 : ''} ${params.row.Dx4Description}`}
									{params?.row?.Dx4Description && <br />}
									{` ${params.row.Dxcode5 !== null ? params.row.Dxcode5 : ''} ${params.row.Dx5Description}`}
									{params?.row?.Dx5Description && <br />}
									{` ${params.row.Dxcode6 !== null ? params.row.Dxcode6 : ''} ${params.row.Dx6Description}`}
									{params?.row?.Dx6Description && <br />}
									{` ${params.row.Dxcode7 !== null ? params.row.Dxcode7 : ''} ${params.row.Dx7Description}`}
									{params?.row?.Dx7Description && <br />}
									{` ${params.row.Dxcode8 !== null ? params.row.Dxcode8 : ''} ${params.row.Dx8Description}`}
									{params?.row?.Dx8Description && <br />}
									{` ${params.row.Dxcode9 !== null ? params.row.Dxcode9 : ''} ${params.row.Dx9Description}`}
									{params?.row?.Dx9Description && <br />}
									{`${params.row.Dxcode10 !== null ? params.row.Dxcode10 : ''} ${params.row.Dx10Description}`}
									{params?.row?.Dx10Description && <br />}
									{`${params.row.Dxcode11 !== null ? params.row.Dxcode11 : ''} ${params.row.Dx11Description}`}
									{params?.row?.Dx11Description && <br />}
									{`${params.row.Dxcode12 !== null ? params.row.Dxcode12 : ''} ${params.row.Dx12Description}`}
									{params?.row?.Dx12Description && <br />}
									{/* `} */}
								</>
							}
						>
							<span
								style={{
									fontWeight: '300',
									fontStyle: 'italic',
									fontSize: '13px',
									textOverflow: 'ellipsis',
									overflow: 'hidden',
									whiteSpace: 'nowrap',
									// maxWidth: '400px',
									width: 160,
								}}
							>
								{`${params.row.Dxcode1 !== null ? params.row.Dxcode1 : ''} ${params.row.Dx1Description}`}{' '}
								<br />
								{` ${params.row.Dxcode2 !== null ? params.row.Dxcode2 : ''} ${params.row.Dx2Description}`}
								<br />
							</span>
						</Tooltip>

						<span
							style={{
								fontWeight: '300',
								fontStyle: 'italic',
								// textDecoration: 'underline',
								textAlign: 'center',
								textWrap: 'wrap',
							}}
						></span>
					</Typography>
				</Box>
			),
		},
		{
			field: 'visitStatus',
			headerName: 'V-Status',
			width: 100,
			sx: { backgroundColor: 'red' },
			renderCell: (params) => {
				const cellStyle =
					params.row.visitStatus === 'A'
						? { color: '#076714' }
						: params.row.visitStatus === 'D'
							? { color: '#CBC311' }
							: params.row.visitStatus === 'B'
								? { color: '#FF7E07' }
								: { color: '#C90D0D' };

				return (
					<Box
						style={cellStyle}
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							textAlign: 'center',
						}}
					>
						{' '}
						{params.value === 'A'
							? 'Approved'
							: params.value === 'B'
								? 'Billed'
								: params.value === 'D'
									? 'Draft'
									: 'Others'}
					</Box>
				);
			},
		},
		// {
		// 	field: 'Action',
		// 	headerName: 'Action',
		// 	width: 100,
		// 	renderCell: (cellValues) => {
		// 		return (
		// 			<Box>
		// 				<img src={eye} width="13.74px" style={{ cursor: 'pointer' }} />
		// 				<PopupState variant="popover" popupId="demo-popup-menu">
		// 					{(popupState) => (
		// 						<React.Fragment>
		// 							<Button {...bindTrigger(popupState)}>
		// 								<img
		// 									src={icon5}
		// 									width="9px"
		// 									style={{ cursor: 'pointer' }}
		// 								/>
		// 							</Button>
		// 							<Menu
		// 								{...bindMenu(popupState)}
		// 								sx={{
		// 									'& .MuiMenu-paper': {
		// 										marginLeft: '-2rem',
		// 									},
		// 								}}
		// 							>
		// 								<MenuItem
		// 									onClick={popupState.close}
		// 									sx={{
		// 										fontFamily: 'Poppins',
		// 										fontWeight: '500',
		// 										fontSize: '14px',
		// 										color: '#4D4F51',
		// 									}}
		// 								>
		// 									Archived Batch
		// 								</MenuItem>
		// 								<MenuItem
		// 									onClick={popupState.close}
		// 									sx={{
		// 										fontFamily: 'Poppins',
		// 										fontWeight: '500',
		// 										fontSize: '14px',
		// 										color: '#4D4F51',
		// 									}}
		// 								>
		// 									Report Batch
		// 								</MenuItem>
		// 								<MenuItem
		// 									onClick={popupState.close}
		// 									sx={{
		// 										fontFamily: 'Poppins',
		// 										fontWeight: '500',
		// 										fontSize: '14px',
		// 										color: '#4D4F51',
		// 									}}
		// 								>
		// 									Delete Batch
		// 								</MenuItem>
		// 							</Menu>
		// 						</React.Fragment>
		// 					)}
		// 				</PopupState>
		// 			</Box>
		// 		);
		// 	},
		// },
	];

	const rows =
		// searchBy !== '' && filterData.length > 0
		// 	? filterData
		// 	:
		filterData?.map((items, i) => {
			return {
				uniqueID: i,

				patientName:
					items?.patient === null
						? ''
						: items?.patient?.Lname + ', ' + items?.patient?.Fname,

				ProviderName:
					// items?.practicestaff?.Lname + ', ' + items?.practicestaff?.Fname : "",
					items?.practicestaff?.Lname || items?.practicestaff?.Fname
						? `${items?.practicestaff?.Lname || ''}${items?.practicestaff?.Fname ? ', ' + items?.practicestaff?.Fname : ''}`
						: '',

				// DateOFBirth: dayjs(
				// 	items.patient === null ? 'NULL' : items.patient.DOB
				// ).format('DD/MM/YYYY'),
				visitDate: dayjs(
					items?.VisitDate === null ? '' : items?.VisitDate
				).format('MM-DD-YYYY'),

				visitStatus: items?.VisitStatus === null ? '' : items?.VisitStatus,

				// charges: items?.visit_cpts
				// 	?.map((data) => (data?.CPTCode === null ? '' : data?.CPTCode))
				// 	.toString(),
				charges: items?.visit_cpts,
				Dxcode1: items?.Dxcode1 === null ? '' : items?.Dxcode1,
				Dxcode2: items?.Dxcode2 === null ? '' : items?.Dxcode2,
				Dxcode3: items?.Dxcode3 === null ? '' : items?.Dxcode3,
				Dxcode4: items?.Dxcode4 === null ? '' : items?.Dxcode4,
				Dxcode5: items?.Dxcode5 === null ? '' : items?.Dxcode5,
				Dxcode6: items?.Dxcode6 === null ? '' : items?.Dxcode6,
				Dxcode7: items?.Dxcode7 === null ? '' : items?.Dxcode7,
				Dxcode8: items?.Dxcode8 === null ? '' : items?.Dxcode8,
				Dxcode9: items?.Dxcode9 === null ? '' : items?.Dxcode9,
				Dxcode10: items?.Dxcode10 === null ? '' : items?.Dxcode10,
				Dxcode11: items?.Dxcode11 === null ? '' : items?.Dxcode11,
				Dxcode12: items?.Dxcode12 === null ? '' : items?.Dxcode12,
				Dx1Description:
					items?.Dx1Description === null ? '' : items?.Dx1Description,
				Dx2Description:
					items?.Dx2Description === null ? '' : items?.Dx2Description,
				Dx3Description:
					items?.Dx3Description === null ? '' : items?.Dx3Description,
				Dx4Description:
					items?.Dx4Description === null ? '' : items?.Dx4Description,
				Dx5Description:
					items?.Dx5Description === null ? '' : items?.Dx5Description,
				Dx6Description:
					items?.Dx6Description === null ? '' : items?.Dx6Description,
				Dx7Description:
					items?.Dx7Description === null ? '' : items?.Dx7Description,
				Dx8Description:
					items?.Dx8Description === null ? '' : items?.Dx8Description,
				Dx9Description:
					items?.Dx9Description === null ? '' : items?.Dx9Description,
				Dx10Description:
					items?.Dx10Description === null ? '' : items?.Dx10Description,
				Dx11Description:
					items?.Dx11Description === null ? '' : items?.Dx11Description,
				Dx12Description:
					items?.Dx12Description === null ? '' : items?.Dx12Description,
			};
		});

	const CustomToolbar = () => {
		const customStyles = `
      .MuiTablePagination-actions,
      .MuiTablePagination-displayedRows {
        display: none !important;
      },
    `;
		const styleElement = document.createElement('style');
		styleElement.innerHTML = customStyles;
		document.head.appendChild(styleElement);
	};

	const paginationMenuOpen = (event) => {
		setPagination(event.currentTarget);
	};

	const paginationMenuClose = () => {
		setPagination(null);
	};
	// pagination logic function is here
	const getItemsForPage = (pageNumber, pageSize) => {
		const startIndex = (pageNumber - 1) * pageSize;
		const endIndex = startIndex + pageSize;
		return allBatchData.slice(startIndex, endIndex);
	};

	const batchDetailsDataFunc = async () => {
		setBatchesLoader(true);
		const resp = await getBatches();
		if (resp?.status == 200) {
			setBatchesDetailsData(resp?.data?.reverse());
			setAllBatchData(resp?.data?.reverse());
			setBatchesLoader(false);
			setfirstBatch(resp?.data?.length > 0 && resp?.data?.reverse()[0]);
			if (resp?.data?.length < 5) {
				setPageSize(resp?.data?.length);
			} else {
				setPageSize(5);
			}
		} else {
			setBatchesDetailsData([]);
			setAllBatchData([]);
		}
	};

	// const getBatchDetailWith_BatchID = async (batch_id) => {
	// 	// debugger
	// 	const resp = await getBatchesWithbatch_id(batch_id);
	// 	setSelectedBatchGrid(resp.data);
	// };

	// function for geting practice Staff data on this screen move to batch textfields
	const getPracticeStaffAllData = async () => {
		const resp = await getPracticeStaff();
		setPracticeStaff(resp.data);
	};

	const handleUpdateBatchFields = (event) => {
		setUpdateBatchName(event.target.value);
	};

	//  body-json for updateBatches
	const updateBatchData = {
		BatchName: updateBatchName,
		practice_id: practiceId_fromLocal,
		// AssignedTo_id: updateAssignTo,
		// AssignedTo_id: 1,
	};
	const updateBatchFunc = async (id, data) => {
		const resps = await updateBatch(id, data);
		if (resps.status == 200) {
			setBatchDeleted(false);
			setPostSucessfully(true);
			setOpenSnackbar(true);
			batchDetailsDataFunc();
		} else {
			setPostSucessfully(false);
			setOpenSnackbar(true);
		}
	};

	const unBatchFunc = async (id, data) => {
		debugger;
		const resps = await updateBatch(id, data);
		if (resps.status == 200) {
			setBatchDeleted(true);
			setOpenSnackbar(true);
			batchDetailsDataFunc();
		}
	};
	// making this function just to avoid snackbar while exporting excel
	const exportBatch = async (id, data) => {
		const resps = await updateBatch(id, data);
		if (resps.status == 200) {
			setBatchDeleted(false);
			batchDetailsDataFunc();
		} else {
			setPostSucessfully(false);
			setOpenSnackbar(true);
		}
	};
	//   Download csv file
	const downloadCSV = (batchID, batchName) => {
		const columns = [
			// Column Fields Name here
			[
				'Patient Name',
				'DOB',
				'Primary Payer',
				'Policy Number',
				'Gender',
				'Provider Name',
				'CPT Codes',
				'Dx Codes ',
				'Location',
				'V-Status',
				'Visit Date',
				'Admission Date',
				'Referring Physician',
				'Discharge date',
			],
		];
		var workbook = utils.book_new();
		var worksheet = utils.json_to_sheet([]);

		utils.sheet_add_aoa(worksheet, columns);
		const exportThisBatchVisitsData = visitData.filter(
			(data) => data.batch_id == batchID
		);
		// Assuming apiData is an array of objects
		exportThisBatchVisitsData?.forEach((item, index) => {
			utils.sheet_add_json(
				worksheet,
				[
					[
						// item?.id,
						`${item?.patient?.Lname + ', ' + item?.patient?.Fname}`,
						`${dayjs(item?.patient?.DOB).format('MM/DD/YYYY')}`,
						`${item?.patient?.patient_insurances[0]?.payer?.Name !== undefined ? item?.patient?.patient_insurances[0]?.payer?.Name : ''}`,
						`${item?.patient?.patient_insurances[0]?.PolicyNumber !== undefined ? item?.patient?.patient_insurances[0]?.PolicyNumber : ''}`,
						`${item?.patient?.Gender === 'F' ? 'Female' : item?.patient?.Gender === 'M' ? 'Male' : item?.patient?.Gender}`,
						`${item?.practicestaff?.Lname + ', ' + item?.practicestaff?.Fname}`,
						item?.visit_cpts
							.map((data) => (data?.CPTCode === null ? '' : data?.CPTCode))
							.toString(),

						`${item?.Dxcode1 === null ? '' : item?.Dxcode1 + ','}${item?.Dxcode2 === null ? '' : item?.Dxcode2 + ','} ${item?.Dxcode3 === null ? '' : item?.Dxcode3 + ','} ${item?.Dxcode4 === null ? '' : item?.Dxcode4 + ','} ${item?.Dxcode5 === null ? '' : item?.Dxcode5 + ','} ${item?.Dxcode6 === null ? '' : item?.Dxcode6 + ','} ${item?.Dxcode7 === null ? '' : item?.Dxcode7 + ','} ${item?.Dxcode8 === null ? '' : item?.Dxcode8 + ','} ${item?.Dxcode9 === null ? '' : item?.Dxcode9 + ','} ${item?.Dxcode10 === null ? '' : item?.Dxcode10 + ','} ${item?.Dxcode11 === null ? '' : item?.Dxcode11 + ','} ${item?.Dxcode12 === null ? '' : item?.Dxcode12 + ','} `,

						`${item?.location !== undefined ? item?.location?.Name : ''}`,
						`${item?.VisitStatus == 'A' ? 'APPROVED' : item?.VisitStatus === null ? 'OTHERS' : item?.VisitStatus == 'B' ? 'BILLED' : item?.VisitStatus == 'D' ? 'DRAFT' : ''}`,

						`${dayjs(item?.VisitDate).format('MM/DD/YYYY')}`,

						dayjs(item?.admission?.Admission_date).format('MM/DD/YYYY'),
						`${item?.referringPhysician?.Fname + ', ' + item?.referringPhysician?.Lname}`,
						item?.admission?.discharge_date
							? dayjs(item?.admission?.discharge_date).format('MM/DD/YYYY')
							: null,
					],
				],
				{ origin: `A${index + 2}`, skipHeader: true }
			);
		});

		utils.book_append_sheet(workbook, worksheet, 'Report');
		writeFile(
			workbook,
			`${batchName}_${dayjs(new Date()).format('MM-DD-YYYY')}.xlsx`
		);
	};
	// Visit Data
	const getVisitData = async () => {
		try {
			setLoader(true);
			const response = await getVisit();
			if (response?.status === 200) setVisitData(response?.data);
			else setVisitData([]);
			setLoader(false);
		} catch (error) {
			console.error('Error fetching data:', error);
			setLoader(false);
		}
	};

	useEffect(() => {
		batchDetailsDataFunc();
		getPracticeStaffAllData();
		getVisitData();
	}, [reRenderAgain]);
	useEffect(() => {
		if (firstBatch) {
			setClicked(firstBatch?.id);
			setCurrentlySelecteBatch({
				id: firstBatch?.id,
				BatchName: firstBatch?.BatchName,
				charges: firstBatch?.num_visits,
				CreatedDate:
					firstBatch?.AssignedTo === null
						? ''
						: dayjs(firstBatch?.CreatedDate).format('MM/DD/YYYY'),
			});
			setSelectedBatchGrid(
				visitData?.filter((i) => i.batch_id == firstBatch?.id)
			);
			setFilterData(visitData?.filter((i) => i.batch_id == firstBatch?.id));
		}
	}, [firstBatch, batchesStatus, visitData]);
	// this useEffect for setting batches according to pagination when it firs time loaded
	useEffect(() => {
		const currentShowingBatches = getItemsForPage(1, pageSize);
		setBatchesDetailsData(currentShowingBatches);
	}, [batchesLoader]);
	return (
		<>
			<Dialog
				open={open}
				// minWidth
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogContent>
					<Box
						width={'100%'}
						display={'flex'}
						justifyContent={'flex-end'}
						alignItems={'center'}
						height={'25px'}
					>
						<Cancel
							sx={{ color: '#0e4374', cursor: 'pointer' }}
							onClick={handleClose}
						/>
					</Box>
					<Typography
						sx={{
							fontFamily: 'Poppins',
							fontWeight: '500',
							fontSize: {
								xl: '32px',
								lg: '32px',
								md: '32px',
								sm: '32px',
								xs: '24px',
							},
							textAlign: 'center',
						}}
					>
						Update Batch
					</Typography>
					<br />
					<Grid container>
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<Typography
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '500',
									fontSize: '14px',
									color: '#000000',
								}}
							>
								Batch Name
							</Typography>
							<TextField
								helperText={
									updateBatchName === ''
										? 'Batch Name Should not be Empty!'
										: ''
								}
								id="outlined-required"
								error={updateBatchName === '' ? true : false}
								fullWidth
								size="medium"
								name="updateBatchNameField"
								value={updateBatchName}
								onChange={handleUpdateBatchFields}
							/>
						</Grid>
						{/* <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<FormControl fullWidth>
								<Typography fontWeight={'bold'}>Assign To</Typography>

								<Select
									sx={{ boxShadow: '1px 1px 10px #79ACF178 inset' }}
									name="assignedTo"
									id="demo-simple-select"
									value={updateAssignTo}
									onChange={(e) => {
										setUpdateAssignTo(e.target.value);
									}}
								>
									{practiceStaff.map((items, i) => {
										return (
											<MenuItem value={items.id} key={i}>
												{items.Fname + ' ' + items.Lname}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Grid> */}
						{/* <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<Typography
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '500',
									fontSize: '14px',
									color: '#000000',
								}}
							>
								Description
							</Typography>
							<TextField
								id="outlined-multiline-static"
								multiline
								rows={4}
								fullWidth
								size="medium"
								name="update_BatchDescriptionField"
							/>
						</Grid> */}
					</Grid>
				</DialogContent>
				<DialogActions>
					<Grid container spacing={2} align="center">
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="right">
							<Button
								style={{ backgroundColor: '#ED2828', width: '75%' }}
								variant="contained"
								size="large"
								autoFocus
								onClick={handleClose}
							>
								Cancel
							</Button>
						</Grid>
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="left">
							<Button
								disabled={updateBatchName === '' ? true : false}
								style={{ backgroundColor: '#FD7702', width: '75%' }}
								variant="contained"
								size="large"
								onClick={() => {
									updateBatchFunc(currentlySelecteBatch.id, updateBatchData);
									setRerenderAgain((prev) => prev + 1);
									handleClose();
								}}
								autoFocus
							>
								Update
							</Button>
						</Grid>
					</Grid>
				</DialogActions>
			</Dialog>
			<Grid container sx={{ display: 'flex', padding: '5px', gap: '5px' }}>
				<Grid
					item
					xl={4}
					lg={4}
					md={5}
					sm={12}
					xs={12}
					sx={{
						border: '1px solid lightgray',
						borderRadius: '7px',
					}}
				>
					{/* <Grid container spacing={2}>
							<Grid item xl={5.5} lg={5.5} md={5.5} sm={5.5} xs={5.5}>
								<Grid container>
									<Grid item xl={1} lg={1} md={1} sm={1} xs={1}></Grid>
									<Grid item xl={11} lg={11} md={11} sm={11} xs={11}>
										<FormControl fullWidth size="small">
											<Select
												value={provider}
												onChange={providerHandler}
												displayEmpty
												inputProps={{ 'aria-label': 'Without label' }}
												sx={{
													fontSize: '14',
													fontFamily: 'Poppins',
													fontWeight: '400',
													color: '#4D4F51',
													marginTop: '1rem',
													'& .MuiOutlinedInput-notchedOutline': {
														boxShadow: '-5px 0px #FD7702',
													},
												}}
											>
												<MenuItem value="">Provider</MenuItem>
												
											</Select>
										</FormControl>
									</Grid>
								</Grid>
							</Grid>
							<Grid item xl={6.5} lg={6.5} md={6.5} sm={6.5} xs={6.5}>
								<Grid container>
									<Grid item xl={11} lg={11} md={11} sm={11} xs={11}>
										<FormControl fullWidth size="small">
											<Select
												value={"viewAllBacthes"}
												displayEmpty
												inputProps={{ 'aria-label': 'Without label' }}
												sx={{
													fontSize: '14',
													fontFamily: 'Poppins',
													fontWeight: '400',
													color: '#4D4F51',
													marginTop: '1rem',
													'& .MuiOutlinedInput-notchedOutline': {
														boxShadow: '-5px 0px #FD7702',
													},
												}}
											>
												<MenuItem value="">View All Batches</MenuItem>
												
											</Select>
										</FormControl>
									</Grid>
									<Grid item xl={1} lg={1} md={1} sm={1} xs={1}></Grid>
								</Grid>
							</Grid>
						</Grid> */}

					<Grid
						item
						xl={12}
						lg={12}
						md={12}
						sm={12}
						xs={12}
						display={'flex'}
						justifyContent={'space-around'}
						alignItems={'center'}
					>
						<Typography
							sx={{
								width: '40%',
								fontFamily: 'Poppins',
								fontWeight: '600',
								fontSize: '19px',
								color: '#000000',
								padding: '10px',
							}}
						>
							Batches Detail
						</Typography>
						<Box width={'50%'}>
							<Box
								sx={{
									width: '100%',
									display: 'flex',
									justifyContent: 'flex-end',
									alignItems: 'flex-end',
								}}
							>
								<SearchIcon sx={{ color: 'action.active' }} />
								<TextField
									onChange={(e) => {
										const searchBatchesByName = allBatchData?.filter(
											(items) => {
												return items?.BatchName.toLowerCase().includes(
													e.target.value.toLowerCase().trim()
												);
											}
										);
										if (e.target.value === '') {
											// setBatchesDetailsData(allBatchData);
											const currentShowingBatches = getItemsForPage(
												1,
												pageSize
											);
											setBatchesDetailsData(currentShowingBatches);
										} else {
											setBatchesDetailsData(searchBatchesByName);
										}
									}}
									id="searchBatchesByName"
									variant="standard"
									placeholder="Search Batch by Name"
								/>
							</Box>
						</Box>
					</Grid>
					{/* <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
							<FormControl fullWidth size="small">
											<InputLabel id="demo-simple-select-label">
												Status
											</InputLabel>

											<Select
												label="Status"
												name="statusSelect"
												value={batchesStatus}
												onChange={batchesStatusHandler}
												inputProps={{ 'aria-label': 'Without label' }}
												sx={{
													fontSize: '14',
													fontFamily: 'Poppins',
													fontWeight: '400',
													color: '#4D4F51',
													'& .MuiOutlinedInput-notchedOutline': {
														boxShadow: '-5px 0px #FD7702',
													},
												}}
											>
												<MenuItem value="">Clear Filter</MenuItem>
												<MenuItem value="E" >Exported</MenuItem>
												<MenuItem value="P">Pending</MenuItem>
											</Select>
										</FormControl>
						</Grid> */}

					{!batchesLoader && batchesDetailsData?.length === 0 && (
						<Box
							width={'100%'}
							// height={'50vh'}
							display={'flex'}
							justifyContent={'center'}
							alignItems={'center'}
						>
							<span
								style={{
									color: '#2081B8',
									marginRight: '5px',
									fontWeight: 'bold',
									// height: '100%',
									// width: '100%',
								}}
							>
								{batchesDetailsData?.length}{' '}
							</span>
							Batches in Record
						</Box>
					)}
					{batchesLoader ? (
						<Box
							sx={{
								width: '100%',
								height: '100%',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								// marginTop: '20px',
							}}
						>
							<CircularProgress />
						</Box>
					) : (
						<Grid
							item
							xl={12}
							lg={12}
							md={12}
							sm={12}
							xs={12}
							sx={{
								overflow: 'auto',
								height: {
									xl: '70vh',
									lg: '70vh',
									md: '65vh',
									sm: '65vh',
									xs: '70vh',
								},
								border: '0.5px solid lightgray',
								padding: '10px 3px',
							}}
						>
							{batchesDetailsData
								// filterBatchWithStatus.length > 0
								// ? filterBatchWithStatus
								// :
								.map((items, i) => {
									return (
										<Box
											key={i}
											onClick={() => {
												handleClick(items);
											}}
											style={textStyles(items.id)}
											// sx={{ margin: '5px 8px' }}
											// sx={{
											// 	height: {
											// 		xl: '78px',
											// 		lg: '88px',
											// 		md: '120px',
											// 		sm: '78px',
											// 		xs: '120px',
											// 	},
											// 	// marginTop: '-0.5rem'
											// }}
											// my={1}
											sx={{
												background: '#E2F5F9',
												// background: ' #EDFFF4',
											}}
										>
											<Grid container>
												<Grid item xl={6.5} lg={6.5} md={6.5} sm={6.5} xs={6.5}>
													<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
														<Typography
															sx={{
																fontFamily: 'Poppins',
																fontWeight: '500',
																fontSize: '13px',
																color: '#000000',
																whiteSpace: 'nowrap',
															}}
														>
															Batch Name:
															<span
																style={{
																	fontFamily: 'Poppins',
																	fontWeight: '600',
																	fontSize: '13px',
																	color: '#407BFF',
																	paddingLeft: '6px',
																}}
															>
																{items?.BatchName?.length > 10
																	? items?.BatchName?.slice(0, 10) + '...'
																	: items?.BatchName}
															</span>
														</Typography>
													</Grid>

													<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
														<Typography
															sx={{
																fontFamily: 'Poppins',
																fontWeight: '500',
																fontSize: '13px',
																color: '#000000',
															}}
														>
															Created Date:{' '}
															<span>
																{/* {items?.AssignedTo?.first_name +
																	' ' +
																	items?.AssignedTo?.last_name} */}
																{dayjs(items?.CreatedDate).format('MM-DD-YYYY')}
															</span>
														</Typography>
													</Grid>
												</Grid>

												<Grid
													item
													xl={4.5}
													lg={4.5}
													md={4.5}
													sm={4.5}
													xs={4.5}
													sx={{ paddingLeft: '15px' }}
												>
													<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
														<Typography
															sx={{
																fontFamily: 'Poppins',
																fontWeight: '500',
																fontSize: '13px',
																color: '#000000',
																whiteSpace: 'nowrap',
																textOverflow: 'ellipsis',
																overflow: 'hidden',
															}}
														>
															Charges:{' '}
															<span style={{ color: '#407BFF' }}>
																{items?.num_visits}
															</span>
														</Typography>
													</Grid>

													<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
														<Typography
															sx={{
																fontFamily: 'Poppins',
																fontWeight: '500',
																fontSize: '13px',
																color: '#000000',
															}}
														>
															{/* Date: */}
															Status:{' '}
															<span
																style={
																	items?.BatchStatus === 'E'
																		? { color: 'green' }
																		: { color: '#CBC311' }
																}
															>
																{' '}
																{items?.BatchStatus === 'E'
																	? 'Exported'
																	: items?.BatchStatus === 'P'
																		? 'Pending'
																		: ''}
															</span>
														</Typography>
													</Grid>
												</Grid>
												<Grid
													item
													xl={1}
													lg={1}
													md={1}
													sm={1}
													xs={1}
													// align="right"
												>
													<PopupState
														variant="popover"
														popupId="demo-popup-menu"
													>
														{(popupState) => (
															<React.Fragment>
																{/* <img
																	src={icon3}
																	width="3.23px"
																	height="14px"
																	// style={{ marginTop: '0.5rem' }}
																/>{' '} */}
																<IconButton>
																	<MoreVertIcon {...bindTrigger(popupState)} />
																</IconButton>
																<Menu
																	{...bindMenu(popupState)}
																	sx={{
																		'& .MuiMenu-paper': {
																			marginLeft: '-2.5rem',
																			marginTop: '-2rem',
																		},
																		'& .MuiPaper-root': {
																			width: '80px',
																			// height: '27%',
																		},
																	}}
																>
																	<MenuItem
																		onClick={() => {
																			unBatchFunc(items.id, {
																				BatchName: items.BatchName,
																				practice_id: practiceId_fromLocal,
																				// AssignedTo_id:
																				// 	items.AssignedTo_id,
																				// AssignedTo_id: 2,
																				Deleted: true,
																			});

																			popupState.close();
																		}}
																		sx={{
																			fontFamily: 'Poppins',
																			fontWeight: '500',
																			fontSize: '11.5px',
																			color: '#000000',
																		}}
																	>
																		Unbatch
																	</MenuItem>

																	<MenuItem
																		onClick={() => {
																			setUpdateBatchName(items.BatchName);
																			setUpdateAssignTo(items.AssignedTo_id);
																			setCurrentlySelecteBatch({
																				id: items?.id,
																				BatchName: items?.BatchName,
																				charges: items?.num_visits,
																				CreatedDate: items?.CreatedDate,
																				AssignedTo_id: items?.AssignedTo_id,
																			});
																			handleClickOpen();
																			popupState.close();
																		}}
																		sx={{
																			fontFamily: 'Poppins',
																			fontWeight: '500',
																			fontSize: '11.5px',
																			color: '#000000',
																		}}
																	>
																		Update
																	</MenuItem>
																	<MenuItem
																		onClick={() => {
																			downloadCSV(items.id, items.BatchName);
																			exportBatch(items.id, {
																				BatchName: items?.BatchName,
																				practice_id: practiceId_fromLocal,
																				// AssignedTo_id: items.AssignedTo,
																				// AssignedTo_id: 1,
																				BatchStatus: 'E',
																			});

																			popupState.close();
																		}}
																		sx={{
																			fontFamily: 'Poppins',
																			fontWeight: '500',
																			fontSize: '11.5px',
																			color: '#000000',
																		}}
																	>
																		Export
																	</MenuItem>
																	{/* <MenuItem
																						onClick={() => {
																							popupState.close();
																						}}
																						sx={{
																							fontFamily: 'Poppins',
																							fontWeight: '500',
																							fontSize: '11.5px',
																							color: '#000000',
																						}}
																					>
																						Create Visit
																					</MenuItem>
																					<MenuItem
																						onClick={popupState.close}
																						sx={{
																							fontFamily: 'Poppins',
																							fontWeight: '500',
																							fontSize: '11.5px',
																							color: '#000000',
																						}}
																					>
																						Archive
																					</MenuItem>
																					<MenuItem
																						onClick={popupState.close}
																						sx={{
																							fontFamily: 'Poppins',
																							fontWeight: '500',
																							fontSize: '11.5px',
																							color: '#ED2828',
																						}}
																					>
																						Delete
																					</MenuItem> */}
																</Menu>
															</React.Fragment>
														)}
													</PopupState>
												</Grid>
											</Grid>
										</Box>
									);
								})}
						</Grid>
					)}
					{/* pagination here */}
					{!batchesLoader &&
						(filterBatchWithStatus?.length > 0 ||
							batchesDetailsData?.length > 0) && (
							<Box display={'flex'} justifyContent={'flex-end'} padding={'5px'}>
								<Box
									// elevation={5}
									sx={{
										// width: '81px',
										// height: '23px',
										border: '1px solid #383434',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										textAlign: 'center',
										fontSize: '12px',
										cursor: 'pointer',
									}}
									onClick={paginationMenuOpen}
								>
									{`${pageSize} / ${allBatchData.length}`}
									<ArrowDropDown fontSize="13px" />
								</Box>
								<Menu
									sx={{
										marginLeft: '13px',
										// width: '81px',
										// margin: '20px',
										// backgroundColor: 'red',
									}}
									anchorEl={pagination}
									open={Boolean(pagination)}
									onClose={paginationMenuClose}
								>
									{[
										allBatchData?.length > 5 && 5,
										allBatchData?.length > 10 && 10,
										allBatchData?.length > 25 && 25,
										allBatchData?.length > 50 && 50,
										allBatchData?.length,
									].map((size, indexNumber) => {
										if (size != false) {
											return (
												<MenuItem
													key={indexNumber}
													onClick={() => {
														setPageSize(size);
														const currentShowingBatches = getItemsForPage(
															1,
															size
														);
														setBatchesDetailsData(currentShowingBatches);
														paginationMenuClose();
													}}
												>
													{size}
												</MenuItem>
											);
										}
									})}
								</Menu>
							</Box>
						)}
				</Grid>
				<Grid
					item
					xl={7.8}
					lg={7.8}
					md={6.8}
					sm={12}
					xs={12}
					sx={{
						border: '1px solid lightgray',
						borderRadius: '8px',
						// border: '2px solid red',
					}}
				>
					{allBatchData?.length > 0 && (
						<Grid
							container
							sx={{
								// border: '1px solid black',
								borderBottom: '1px solid lightgray',
								padding: '4px 10px ',
								display: 'flex',
								alignItems: 'center',
							}}
						>
							<Grid item xl={3} lg={3} md={3} sm={3} xs={12}>
								<Grid container>
									<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
										<Typography
											sx={{
												fontFamily: 'Poppins',
												fontWeight: '500',
												// fontSize: '13px',
												color: '#000000',
												whiteSpace: 'nowrap',
												fontSize: {
													xl: '13px',
													lg: '13px',
													md: '10px',
													sm: '10px',
													xs: '9px',
												},
											}}
										>
											Batch Name:{' '}
											<span style={{ color: '#96979A' }}>
												{currentlySelecteBatch?.BatchName?.length > 12
													? currentlySelecteBatch?.BatchName?.slice(0, 12) +
														'...'
													: currentlySelecteBatch?.BatchName}
											</span>
										</Typography>
									</Grid>
								</Grid>
							</Grid>
							<Grid container item xl={2} lg={2} md={2} sm={4} xs={12}>
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<Typography
										sx={{
											fontFamily: 'Poppins',
											fontWeight: '500',
											// fontSize: '13px',
											color: '#000000',
											fontSize: {
												xl: '13px',
												lg: '12px',
												md: '10px',
												sm: '10px',
												xs: '9px',
											},
										}}
									>
										Charges:{' '}
										<span style={{ color: '#96979A' }}>
											{' '}
											{currentlySelecteBatch?.charges}
										</span>
									</Typography>
								</Grid>
							</Grid>
							<Grid item xl={3} lg={3} md={3} sm={4} xs={12}>
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<Typography
										sx={{
											fontFamily: 'Poppins',
											fontWeight: '500',
											// fontSize: '13px',
											color: '#000000',
											whiteSpace: 'nowrap',
											fontSize: {
												xl: '13px',
												lg: '12px',
												md: '10px',
												sm: '10px',
												xs: '9px',
											},
										}}
									>
										Date:{' '}
										<span style={{ color: '#96979A' }}>
											{currentlySelecteBatch?.CreatedDate}
										</span>
									</Typography>
								</Grid>
							</Grid>

							<Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
								<TextField
									variant="outlined"
									placeholder="Search By Patient Name"
									value={searchBy}
									onChange={handleSearchByFilter}
									// sx={{
									// 	marginTop: {
									// 		xl: '-0.5rem',
									// 		lg: '-0.5rem',
									// 		md: '0.5rem',
									// 		sm: '0.5rem',
									// 		xs: '0rem',
									// 	},
									// }}
									InputProps={{
										endAdornment: (
											// <img src={Icon} width="14.22px" height="14.22px" />
											<SearchIcon fontSize="small" />
										),
									}}
									fullWidth
									size="small"
								/>
							</Grid>
						</Grid>
					)}
					<Box
						sx={{
							height: {
								xl: '75vh',
								lg: '75vh',
								md: '70vh',
								sm: '70vh',
								xs: '75vh',
							},
						}}
					>
						{loader ? (
							<Box
								sx={{
									width: '100%',
									height: '100%',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}
							>
								<CircularProgress />
							</Box>
						) : allBatchData?.length > 0 ? (
							<DataGrid
								// rows={selectedBatchGrid}
								rows={rows}
								columns={columns}
								columnHeaderHeight={40}
								initialState={{
									pagination: { paginationModel: { pageSize: 5 } },
								}}
								pageSizeOptions={[5, 10, 25]}
								rowHeight={65}
								// checkboxSelection
								disableRowSelectionOnClick
								sx={{
									'& .MuiDataGrid-columnHeader': {
										backgroundColor: '#2081B8',
										color: '#FFFFFF',
										fontFamily: 'Poppins',
										fontWeight: '500',
										fontSize: '13px',
									},
									'& .MuiDataGrid-footerContainer': {
										justifyContent: 'flex-end',
										backgroundColor: '#DCF0FF',
									},
									'& .MuiTablePagination-selectLabel': {
										fontFamily: 'Poppins',
										fontWeight: '500',
										fontSize: '15px',
									},
									'& .MuiInputBase-root': {
										border: '0.5px solid #383838',
										width: '57px',
										height: '30px',
										borderRadius: '10%',
										backgroundColor: 'white',
									},
								}}
								slotProps={{
									pagination: { labelRowsPerPage: 'Entries Per Page' },
								}}
								getRowId={(row) => row.uniqueID}
							/>
						) : (
							<Box
								width={'100%'}
								height={'50vh'}
								display={'flex'}
								justifyContent={'center'}
								alignItems={'center'}
							>
								<span
									style={{
										color: '#2081B8',
										marginRight: '5px',
										fontWeight: 'bold',
										// height: '100%',
										// width: '100%',
									}}
								>
									{allBatchData?.length}{' '}
								</span>
								Batches in Record
							</Box>
						)}
					</Box>

					{/* SnackBar */}
					<Snackbar
						open={openSnackbar}
						autoHideDuration={3000}
						onClose={handleCloseSnackbar}
						anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
					>
						<Alert
							onClose={handleCloseSnackbar}
							severity={
								!postSucessfully ? 'error' : batchDeleted ? 'error' : 'success'
							}
							variant="filled"
							sx={{
								width: '100%',
								height: '3.5rem',
								textAlign: 'center',
								fontSize: '1.1rem',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
							action={
								<React.Fragment>
									<span
										onClick={handleCloseSnackbar}
										style={{
											cursor: 'pointer',
											m: 'auto 0',
											fontSize: '13px',
											color: 'rgb(231, 231, 231)',
										}}
									>
										Close
									</span>
								</React.Fragment>
							}
						>
							{!postSucessfully
								? 'Error!'
								: batchDeleted
									? 'Batch is Unbtached'
									: 'Batch Update Successfully!'}
						</Alert>
					</Snackbar>
				</Grid>
			</Grid>
		</>
	);
}

export default Batches;
